'use strict';

require("../../company/publications/CompanyPublicationActivity.js");
require("../../company/publications/CompanyPublicationActivityDirective.js");
require("../../company/publications/order/CompanyPublicationOrderService.js");

function CompanyGuestPublicationOrderDetailCtrl(
  $scope,
  publication,
  order,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyPublicationService,
  orderService,
  $sce,
  $q,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.translations = translations;
  $scope.activityService = activityService;
  $scope.order = order;

  $scope.orderPlants = [];
  $scope.orderUsers = [];
  $scope.orderProjects = [];

  if ($scope.order) {
    var params = {
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      massoptimeringId: $scope.order.id
    };

    var orderPlants = orderService.queryPlants(params).$promise;
    var orderUsers = orderService.queryUsers(params).$promise;
    var orderProjects = orderService.queryProjects(params).$promise;

    $q.all([orderPlants, orderUsers, orderProjects]).then(function(data){
      $scope.orderPlants = data[0];
      $scope.orderUsers = data[1];
      $scope.orderProjects = data[2];
    });
  }

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
        'content': '',
        'template': 'partials/company-guest/order/detail/latest.html',
        'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

}

CompanyGuestPublicationOrderDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }],
  order: ['$stateParams', 'CompanyPublicationOrderService', 'publication', function($stateParams, CompanyPublicationOrderService, publication){
    if (publication.features.currentOrderId) {
      return CompanyPublicationOrderService.get({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: publication.features.currentCompanyOrderId
      }).$promise;
    }

    return false;
  }]
};
module.exports = CompanyGuestPublicationOrderDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationOrderDetailCtrl', [
  '$scope',
  'publication',
  'order',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyPublicationService',
  'CompanyPublicationOrderService',
  '$sce',
  '$q',
  'config',
  'activityService',
  CompanyGuestPublicationOrderDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/order/CompanyGuestPublicationOrderDetailCtrl.js
// module id = 296
// module chunks = 0